import { jsx as _jsx } from "react/jsx-runtime";
import { GOAL_TYPE } from '../constants/goals';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedCurrency from 'I18n/components/FormattedCurrency'; // @ts-expect-error js/utils/formatCurrencyCode.js' implicitly has an 'any' type

import formatCurrencyCode from 'I18n/utils/formatCurrencyCode';
export const GOAL_TYPE_FORMAT_CONFIG = goal => {
  return {
    [GOAL_TYPE.FIRST_FORM_SUBMISSION]: {
      unitOfMeasurement: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "goals-reporting-lib.table.firstFormSubmission.unitOfMeasurement"
      }),
      formatTargetAmount: amount => /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'goals-reporting-lib.table.firstFormSubmission.formatTargetAmount',
        options: {
          count: amount
        }
      })
    },
    [GOAL_TYPE.NUMBER_OF_CONTACTS_IN_LIFECYCLE]: {
      unitOfMeasurement: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "goals-reporting-lib.table.numberContactsInLifecycle.unitOfMeasurement"
      }),
      formatTargetAmount: amount => /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'goals-reporting-lib.table.numberContactsInLifecycle.formatTargetAmount',
        options: {
          count: amount
        }
      })
    },
    [GOAL_TYPE.NUMBER_OF_NETWORK_CONVERSIONS]: {
      unitOfMeasurement: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "goals-reporting-lib.table.networkConversions.unitOfMeasurement"
      }),
      formatTargetAmount: amount => /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'goals-reporting-lib.table.networkConversions.formatTargetAmount',
        options: {
          count: amount
        }
      })
    },
    [GOAL_TYPE.COST_PER_CONTACT_IN_LIFECYCLE]: {
      unitOfMeasurement: formatCurrencyCode(goal.currency),
      formatTargetAmount: amount => /*#__PURE__*/_jsx(FormattedCurrency, {
        currencyCode: goal.currency,
        value: amount
      })
    }
  };
};